import type { EnumOption } from "@/components/enum-select";

// Canonical option sets for the otherwise free-text grow / plant-profile
// fields. The backend stores plain strings; EnumSelect's "Other…" path keeps
// off-list and legacy values valid, so these only streamline the common cases.

export const SYSTEM_TYPE_OPTIONS: EnumOption[] = [
  { value: "DWC", label: "DWC" },
  { value: "Kratky", label: "Kratky" },
  { value: "NFT", label: "NFT (Nutrient Film)" },
  { value: "Drip", label: "Drip" },
  { value: "Ebb & Flow", label: "Ebb & Flow" },
  { value: "Aeroponic", label: "Aeroponic" },
  { value: "Wick", label: "Wick" },
  { value: "Vertical Tower", label: "Vertical Tower" },
];

export const FEEDER_CLASS_OPTIONS: EnumOption[] = [
  { value: "light", label: "Light" },
  { value: "medium", label: "Medium" },
  { value: "heavy", label: "Heavy" },
];

export const GROW_STATE_OPTIONS: EnumOption[] = [
  { value: "active", label: "Active" },
  { value: "seedling", label: "Seedling" },
  { value: "vegetative", label: "Vegetative" },
  { value: "flowering", label: "Flowering" },
  { value: "fruiting", label: "Fruiting" },
  { value: "harvested", label: "Harvested" },
  { value: "dormant", label: "Dormant" },
  { value: "archived", label: "Archived" },
];

// Plant-profile taxonomy. Categories/stages mirror the seeded system profiles.
export const PLANT_CATEGORY_OPTIONS: EnumOption[] = [
  { value: "leafy green", label: "Leafy green" },
  { value: "herb", label: "Herb" },
  { value: "fruiting", label: "Fruiting" },
  { value: "root", label: "Root" },
  { value: "flowering", label: "Flowering" },
];

export const PLANT_STAGE_OPTIONS: EnumOption[] = [
  { value: "seedling", label: "Seedling" },
  { value: "vegetative", label: "Vegetative" },
  { value: "flowering", label: "Flowering" },
  { value: "fruiting", label: "Fruiting" },
  { value: "mature", label: "Mature" },
];
